import React from 'react';
import { RichText } from 'components/rich-text/RichText';
import { TextBlock } from 'components/text-block/TextBlock';
import { Text } from 'components/text/Text';

export const StoriesSlice = ({ title, text, color, aside, isSlice }) => {
  return (
    <TextBlock
      title={title}
      text={RichText.render(text)}
      color={color}
      textLength={RichText.asText(text)?.length}
      isSlice={isSlice}
    >
      {aside && <Text hasLayout={false} text={RichText.render(aside)} />}
    </TextBlock>
  );
};

export default StoriesSlice;
